import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, withModifiers as _withModifiers, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { id: "rarity" }
const _hoisted_2 = { class: "container-default max-w-6xl grid lg:grid-cols-3 gap-12" }
const _hoisted_3 = { class: "lg:col-span-2" }
const _hoisted_4 = { class: "space-y-6 flex flex-col" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("h2", { class: "title uppercase" }, "About", -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("h3", { class: "text-xs tracking-widest uppercase font-semibold" }, " Collection insights, process and rarity system ", -1)
const _hoisted_7 = { class: "space-y-3" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("p", { class: "" }, " In total 1000 renders were created using a randomizer tool with an integrated rarity system that assigned unique trait combinations of 200+ traits consisting of headwear, hairstyle, clothes, character avatar, facial expression, and jewelry. The rarity system assigns lower drop rates to more complex traits like clothes with multiple logo variations or pinned metal accessories. Moreover, simpler traits like headwear with single logo variants or chains without a pendant are more likely to drop due to their less complex structure. ", -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("p", { class: "" }, " For each of the five character avatars: Jordan, Chris, Francesco, Hyuk, and Sanjith, 50 renders were hand-picked after the randomization process to achieve a balanced representation within the collection of the most mesmerizing trait combinations. ", -1)
const _hoisted_10 = { class: "" }
const _hoisted_11 = /*#__PURE__*/_createTextVNode(" to create trait combinations - can you spawn a rare ")
const _hoisted_12 = /*#__PURE__*/_createTextVNode(" patterned puffed hood jacket or an outstanding golden hooded mask? ")
const _hoisted_13 = { class: "ml-auto md:ml-0" }
const _hoisted_14 = /*#__PURE__*/_createTextVNode("Shuffle")
const _hoisted_15 = {
  key: 0,
  class: "grid grid-cols-1 gap-6 lg:col-span-1"
}
const _hoisted_16 = ["src", "alt"]
const _hoisted_17 = { class: "space-y-2" }
const _hoisted_18 = { class: "grid grid-cols-2 gap-2" }
const _hoisted_19 = { class: "block" }
const _hoisted_20 = /*#__PURE__*/_createTextVNode("Collapse attributes")
const _hoisted_21 = /*#__PURE__*/_createTextVNode("Expand for all attributes")

import { ChevronUpIcon, ChevronDownIcon } from "@heroicons/vue/24/outline";
import AppButton from "@/components/app/AppButton.vue";
import AppPanel from "@/components/app/AppPanel.vue";
import { useCycleList } from "@vueuse/core";
import { tokens } from "@/constants";
import { ref } from "vue";
import DripversityIcon from "@/components/icons/DripversityIcon.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'HomeRarity',
  setup(__props) {

const collapse = ref(false);

const { state, index, next } = useCycleList<{ image: any; attributes: any }>(
    tokens.all
);

return (_ctx: any,_cache: any) => {
  const _directive_animate = _resolveDirective("animate")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_4, [
          _hoisted_5,
          _hoisted_6,
          _createElementVNode("div", _hoisted_7, [
            _hoisted_8,
            _hoisted_9,
            _createElementVNode("p", _hoisted_10, [
              _createElementVNode("button", {
                class: "link-2",
                onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_unref(next)()), ["prevent"]))
              }, " Shuffle "),
              _hoisted_11,
              _createVNode(DripversityIcon, { class: "text-dripversity" }),
              _hoisted_12
            ])
          ]),
          _createElementVNode("div", _hoisted_13, [
            _createVNode(AppButton, {
              onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (_unref(next)()), ["prevent"])),
              color: "secondary"
            }, {
              default: _withCtx(() => [
                _hoisted_14
              ]),
              _: 1
            })
          ])
        ])), [
          [
            _directive_animate,
            void 0,
            void 0,
            { stagger: true }
          ]
        ])
      ]),
      (_unref(state))
        ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
            _withDirectives(_createElementVNode("img", {
              src: _unref(state).image,
              alt: _unref(index) + ' rarity',
              class: "rounded-xl w-full"
            }, null, 8, _hoisted_16), [
              [_directive_animate]
            ]),
            _createElementVNode("div", _hoisted_17, [
              _withDirectives((_openBlock(), _createElementBlock("ul", _hoisted_18, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(collapse.value
                                ? _unref(state).attributes
                                : _unref(state).attributes.slice(0, 4), (attribute) => {
                  return (_openBlock(), _createElementBlock("li", {
                    class: "flex w-full",
                    key: attribute
                  }, [
                    _createVNode(AppPanel, {
                      truncate: true,
                      reverse: true,
                      size: "xs",
                      color: "gray",
                      title: attribute.value,
                      subtitle: attribute?.trait_type || ''
                    }, null, 8, ["title", "subtitle"])
                  ]))
                }), 128))
              ])), [
                [
                  _directive_animate,
                  void 0,
                  void 0,
                  { stagger: true }
                ]
              ]),
              _createVNode(AppButton, {
                onClick: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (collapse.value = !collapse.value), ["prevent"])),
                size: "xs",
                color: "transparent",
                class: "!p-0"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("span", _hoisted_19, [
                    (collapse.value)
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                          _hoisted_20
                        ], 64))
                      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                          _hoisted_21
                        ], 64))
                  ]),
                  (collapse.value)
                    ? (_openBlock(), _createBlock(_unref(ChevronUpIcon), {
                        key: 0,
                        class: "w-2 h-2 block"
                      }))
                    : (_openBlock(), _createBlock(_unref(ChevronDownIcon), {
                        key: 1,
                        class: "w-2 h-2 block"
                      }))
                ]),
                _: 1
              })
            ])
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

})